var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-row',_vm._l((_vm.dataCard),function(card,index){return _c('vs-col',{key:index,attrs:{"vs-type":"flex","vs-justify":"center","vs-align":"center","vs-w":"2"}},[_c('Card',{attrs:{"card":_vm.excludeKey(_vm.listKeyForExclude, card)}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }